import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, ConfirmationService, MultiSelectModule, DataTableModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { SispacSharedModule } from '../shared/sispac-shared.module';

import { vagaRouting } from './vaga.routing';

import { GerenciarPropostasComponent } from './gerenciar/gerenciar-propostas.component';
import { AnalisarPropostaComponent } from './analisar-proposta/analisar-proposta.component';
import { GerenciarIndicacaoComponent } from './indicacao/gerenciar-indicacao.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        vagaRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, MultiSelectModule,

        Ng2BRPipesModule,

        SispacSharedModule,
        DataTableModule
    ],
    providers: [ ConfirmationService ],
    declarations: [
        GerenciarPropostasComponent,
        AnalisarPropostaComponent,
        GerenciarIndicacaoComponent,
    ],
})
export class VagaModule { }



// WEBPACK FOOTER //
// ./src/app/components/vaga/vaga.module.ts